export default function Graphics() {
  return (
    <div>
      <h1>Graphics Component</h1>
    </div>
  );
}
